import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import countiesService from "../../../../services/legacy/countiesService";
import countriesService from "../../../../services/legacy/countriesService";
import statesService from "../../../../services/legacy/statesService";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const ZipCodesPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = [{"tabId": "general", "label": "axFormLayout.zipcode.tabs.general", "order": 1, "groups": [], "fields": ["zipcode", "city", "cityalias", "streetname", "fromnum", "tonum", "evenodd"]}];

  const baseColumns = [
    {
      key: "zipcode",
      label: "zipCodes.zipCode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "city",
      label: "zipCodes.city",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "streetname",
      label: "zipCodes.streetname",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "fromnum",
      label: "zipCodes.fromnum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "tonum",
      label: "zipCodes.tonum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "evenodd",
      label: "zipCodes.evenodd",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      filterType: "select",
      enumName: "AllEvenOdd",
      options: [{"value": 0, "label": "Todos los números de calle", "labelKey": "axEnums.AllEvenOdd.0"}, {"value": 1, "label": "Par", "labelKey": "axEnums.AllEvenOdd.1"}, {"value": 2, "label": "Impar", "labelKey": "axEnums.AllEvenOdd.2"}]    },
    {
      key: "county",
      label: "zipCodes.county",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      relatedService: countiesService,
      optionLabel: "name",
      optionValue: "countyid",
      lookupSearchMode: "or",
      lookupDependsOn: [{"localField": "country", "remoteFilterField": "countryid"}, {"localField": "state", "remoteFilterField": "stateid"}]    },
    {
      key: "country",
      label: "zipCodes.country",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      relatedService: countriesService,
      optionLabel: "name",
      optionValue: "countryid",
      lookupSearchMode: "or"    },
    {
      key: "state",
      label: "zipCodes.state",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "select",
      relatedService: statesService,
      optionLabel: "name",
      optionValue: "stateid",
      lookupSearchMode: "or",
      lookupDependsOn: [{"localField": "country", "remoteFilterField": "countryid"}]    },
    {
      key: "cityalias",
      label: "zipCodes.cityalias",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "recId",
      label: "zipCodes.recId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "modifieddate",
      label: "zipCodes.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "datetime",
      filterType: "date"    },
    {
      key: "dataAreaId",
      label: "zipCodes.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: true,
    canEdit: true,
    canDelete: false
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="zipCodes"
      permissionPrefix="legacy.zipCodes"
      icon={faLocationDot}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default ZipCodesPageGen;